import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout della sezione notifiche.
 *
 * Serve perché `notifications.$notificationId` è **figlio** di questa rotta: con la pagina
 * montata qui invece dell'`Outlet`, aprire una notifica cambiava l'indirizzo e lasciava a
 * schermo l'elenco — la scheda non aveva dove comparire. Stesso schema di `leave`.
 */
export const Route = createFileRoute('/_app/notifications')({ component: () => <Outlet /> });
